import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Skeleton, Tooltip } from 'antd'
import { ShoppingCartOutlined } from '@ant-design/icons'
import { useDispatch } from 'react-redux'
import { fetchMoreData, searchAuctionRows } from 'utils'
import { awsconfig, config } from 'configs'
import { useHistory } from 'react-router-dom'
import { useAuthSelector } from 'store/authSlice/authReducer'
import { AiFillEye } from 'react-icons/ai'
import InfiniteScroll from 'react-infinite-scroll-component'
import {
  getAuctionBySubscriber,
  updateAuctionStatus,
} from 'store/auctionSlice/auctionActions'
import {
  auctionActions,
  useAuctionSelector,
} from 'store/auctionSlice/auctionReducer'
import sample from 'assets/images/sample/sample1.png'
import { Can } from 'permissions'

function InactiveList({ searchText, sortKey }) {
  const dispatch = useDispatch()
  const history = useHistory()

  const { organization } = useAuthSelector()
  const { loading, inactive } = useAuctionSelector()

  const filteredInactive = inactive.filter(
    (auction) => auction?.OrganizationId === organization?.id,
  )

  const [current, setCurrent] = useState([])

  const searchedData = searchAuctionRows(filteredInactive, searchText)

  useEffect(() => {
    setCurrent(searchedData.slice(0, config.itemFirstLoad))
    // eslint-disable-next-line
  }, [inactive, searchText])

  const fetchData = () => {
    dispatch(getAuctionBySubscriber(sortKey, organization?.id))
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line
  }, [sortKey])

  const handleAuctionSelected = (e, auction) => {
    e.preventDefault()
    e.stopPropagation()
    dispatch(auctionActions.setAuction(null))
    history.push(`auction/${auction.Id}`)
  }

  const handleUpdateEvent = (auction) => {
    dispatch(updateAuctionStatus(auction?.Id, auction?.ActiveInd, fetchData))
  }

  return (
    <Skeleton loading={loading} active paragraph={{ rows: 18 }}>
      <div className="t-flex t-flex-col t-justify-between t-h-full">
        <InfiniteScroll
          dataLength={current.length}
          next={() => fetchMoreData(current, setCurrent, searchedData)}
          hasMore={current.length < searchedData.length}
          loader={
            <div className="t-flex t-justify-center t-items-center">
              {/* <Spin /> */}
            </div>
          }
        >
          <Row gutter={[24, 24]}>
            {current.length === 0 && (
              <div className="t-h-96 t-flex t-justify-center t-items-center t-w-full">
                <div className="t-flex t-flex-col t-items-center t-space-y-2">
                  <ShoppingCartOutlined
                    style={{ fontSize: '2rem' }}
                    className="t-text-secondary-100"
                  />
                  <p>No records found</p>
                </div>
              </div>
            )}
            {current.map((item, index) => (
              <Col span={24} lg={8} className="mb-24" key={index}>
                <Card
                  bordered
                  hoverable
                  cover={
                    <img
                      alt="example"
                      className="t-w-full t-h-48 t-object-cover t-rounded-md"
                      src={
                        item?.Flyer?.fileName
                          ? awsconfig.bucketUrl + item?.Flyer?.fileName
                          : item?.OrganizationBackgroundImage
                          ? awsconfig.bucketUrl +
                            item?.OrganizationBackgroundImage?.fileName
                          : sample
                      }
                    />
                  }
                  onClick={(e) => handleAuctionSelected(e, item)}
                >
                  <div className="t-flex t-justify-between t-items-center">
                    <h5 className="t-text-2xl t-text-secondary-100 t-font-bold t-truncate">
                      <Tooltip title={item?.Title}>{item?.Title}</Tooltip>
                    </h5>

                    <Can I={config.actions.edit} a={config.components.auction}>
                      <AiFillEye
                        fontSize="2rem"
                        className="t-cursor-pointer t-text-secondary-100"
                        onClick={() => handleUpdateEvent(item)}
                      />
                    </Can>
                  </div>

                  <div className="t-flex t-justify-between">
                    <div className="card-tag t-font-thin t-text-secondary-100">
                      {item?.OrganizationName}
                    </div>
                  </div>
                  <p className="t-line-clamp-1 t-text-sm">{item?.Details}</p>
                </Card>
              </Col>
            ))}
          </Row>
        </InfiniteScroll>
      </div>
    </Skeleton>
  )
}

export { InactiveList }
